/**
 * Enum for partner plan codes
 */
export enum PlanEnum {
    /**
     * Free plan - basic features with bucket storage
     */
    FREE = 'FREE',
    
    /**
     * Lite plan - intermediate features with bucket storage (no CDN)
     */
    LITE = 'LITE',

    /**
     * Pro plan - advanced features with CDN access
     */
    PRO = 'PRO'
} 